import React, { useContext, useState } from 'react'
import { PROFESSIONAL, markAsReadApi } from '../../Constants';
import { Context } from '../../Context/Context';
import { getNotificationSeeMoreLink } from '../../Utils';
import { useNavigate } from 'react-router-dom';
import TestModal from 'Modals/TestModal';
import moment from 'moment';
import { FileText, User } from 'lucide-react';

// "2m ago" / "3h ago" / "Yesterday, 4:22pm" / "Sep 2, 9:47am" / "Aug 29, 2025"
export const formatNotificationTime = (d) => {
    const m = moment(d);
    const now = moment();
    const mins = now.diff(m, 'minutes');
    if (mins < 1) return 'Just now';
    if (mins < 60) return mins + 'm ago';
    if (m.isSame(now, 'day')) return now.diff(m, 'hours') + 'h ago';
    if (m.isSame(now.clone().subtract(1, 'day'), 'day')) return 'Yesterday, ' + m.format('h:mma');
    if (m.isSame(now, 'year')) return m.format('MMM D, h:mma');
    return m.format('MMM D, YYYY');
};

// type "1" account +, "2" account -, "3" case +, "4" case -
const toneOf = (type) => (type === "2" || type === "4") ? 'negative' : 'positive';

function NotificationListItem({attorney, msg, isNotificationSearch = false, caseNumber, setUpdateList, isLast = false, ownFeed = false}) {
    const [showModal, setShowModal] = useState(false);
    const [currentCaseId, setCurrentCaseId] = useState(null);
    const [locallyRead, setLocallyRead] = useState(false);
    const {userDetails, makeApiCallFunc, setNotificationCount} = useContext(Context);
    const role = userDetails?.role;
    const userInfo = attorney ? attorney.userId : userDetails;
    const navigate = useNavigate();
    const [, setSingleCase] = useState(null);

    const unread = !msg?.is_read && !locallyRead;

    const markAsRead = (id, refreshCall = true) => {
        if (!unread) return;
        setLocallyRead(true);
        if (ownFeed && setNotificationCount) setNotificationCount((prev) => Math.max(0, (prev || 0) - 1));
        makeApiCallFunc(
            markAsReadApi+"/"+id,
            {
                userId: userInfo?._id,
                onlyCases: attorney ? true : false,
                caseNumber
            },
            () => { if (refreshCall) setUpdateList && setUpdateList((prev) => !prev); },
            (error) => console.log(error)
        )
    }

    const openNotification = () => {
        markAsRead(msg._id, false);
        // assistants working for an attorney keep the case popup; everyone else opens the case page
        if (attorney && role === PROFESSIONAL && msg?.notificationCategory === 1 && msg?.additionalInfo?.caseId) {
            setShowModal(true);
            setCurrentCaseId(msg?.additionalInfo?.caseId);
        } else {
            const link = getNotificationSeeMoreLink(msg, role);
            if (link) navigate(link);
        }
    }

    if (!msg) return null;
    const tone = toneOf(msg.type);
    const Icon = (msg.type === "1" || msg.type === "2") ? User : FileText;
    const iconColor = !unread ? 'rgba(20,33,61,.4)' : (tone === 'negative' ? '#9a3b2e' : '#3a7d4f');
    const iconBg = !unread ? 'rgba(20,33,61,.06)' : (tone === 'negative' ? 'rgba(154,59,46,.1)' : 'rgba(58,125,79,.12)');
    const title = msg.title ? (msg.caseNumber ? msg.caseNumber + " — " + msg.title : msg.title) : "Notification";

  return (
    <>
    {
        showModal &&
        <TestModal
         attorney={attorney}
         onClose={()=>{
            setUpdateList && setUpdateList((prev) => !prev);
            setShowModal(false)}
         }
         uploadNew={showModal}
         caseId={currentCaseId}
         caseNumber={msg?.caseNumber}
        setSingleCase={setSingleCase}
        />
    }
    <div
        onClick={openNotification}
        className='group flex cursor-pointer font-plexsans transition-colors hover:bg-[rgba(138,98,49,0.03)]'
        style={{ gap: '16px', padding: '20px 4px', borderBottom: isLast ? 'none' : '1px solid rgba(20,33,61,.08)' }}
    >
        <div className='flex-none relative flex items-center justify-center rounded-full' style={{ width: '42px', height: '42px', background: iconBg }}>
            <Icon size={17} strokeWidth={1.8} color={iconColor} />
            {unread && <span className='absolute rounded-full' style={{ top: '-1px', right: '-1px', width: '9px', height: '9px', background: '#8a6231', border: '2px solid #f7f4ed' }} />}
        </div>
        <div className='flex-1 min-w-0'>
            <div className='flex justify-between items-start' style={{ gap: '16px' }}>
                <span style={{ fontSize: '15px', lineHeight: 1.4, fontWeight: unread ? 600 : 400, color: unread ? '#14213d' : 'rgba(20,33,61,.6)' }}>{title}</span>
                <span className='flex-none whitespace-nowrap' style={{ font: "400 11.5px/1.6 'IBM Plex Mono',monospace", color: 'rgba(20,33,61,.4)' }}>{formatNotificationTime(msg.created_at)}</span>
            </div>
            {msg.content &&
                <p style={{ margin: '4px 0 0', fontSize: '13.5px', lineHeight: 1.55, color: unread ? 'rgba(20,33,61,.6)' : 'rgba(20,33,61,.45)' }}>{msg.content}</p>
            }
            {unread && !isNotificationSearch &&
                <span
                    onClick={(e) => { e.stopPropagation(); markAsRead(msg._id); }}
                    className='inline-block opacity-0 group-hover:opacity-100 transition-opacity hover:text-tanDark'
                    style={{ marginTop: '6px', fontSize: '12px', fontWeight: 500, color: '#8a6231' }}
                >Mark as read</span>
            }
        </div>
    </div>
    </>
  )
}

export default NotificationListItem
